import { CABINET_CDN_PATH } from '../../cabinet-constants';
import { CustomSize, Deadline, Guarantee, Project } from './components';

export type HeaderCardStructure = {
  text: string;
  icon: {
    src: string;
    alt: string;
  };
  modal: React.FC<{ onCloseModal: () => void; signUpHref: string }>;
};

export const CABINET_BENEFITS_LIST: HeaderCardStructure[] = [
  {
    text: 'Бесплатный\nдизайн-проект',
    icon: {
      src: `${CABINET_CDN_PATH}/benefits/project-icon.png/project-icon.png`,
      alt: 'Бесплатный дизайн-проект',
    },
    modal: Project,
  },
  {
    text: 'Размеры на заказ\nс точностью 1 мм',
    icon: {
      src: `${CABINET_CDN_PATH}/benefits/custom-size-icon.png/custom-size-icon-02.png`,
      alt: 'Индивидуальные размеры',
    },
    modal: CustomSize,
  },
  {
    text: 'Сроки изготовления\nот 21\u00A0дня',
    icon: {
      src: `${CABINET_CDN_PATH}/benefits/deadline-icon.png/deadline-icon.png`,
      alt: 'Сроки изготовления от 21 дня',
    },
    modal: Deadline,
  },
  {
    text: 'Гарантия качества\nот 2\u00A0лет',
    icon: {
      src: `${CABINET_CDN_PATH}/benefits/guarantee-icon.png/guarantee-icon.png`,
      alt: 'Гарантия качества',
    },
    modal: Guarantee,
  },
];
